import { z } from 'zod';

export const PERSON_NAME_REGEX = /^\p{L}+(?:[ '-]\p{L}+)*$/u;

export const PERSON_NAME_MAX_LENGTH = 50;

export const personNameRegexMessage = (label: string): string => `${label} może zawierać tylko litery, spacje, myślniki i apostrofy`;

export const PHONE_REGEX = /^\+?[\d\s()-]+$/;
export const PHONE_MIN_DIGITS = 7;
export const PHONE_MAX_DIGITS = 17;

const countDigits = (value: string): number => value.match(/\d/g)?.length ?? 0;

export const phoneSchema = (label = 'Numer telefonu') =>
  z
    .string()
    .trim()
    .min(1, `${label} jest wymagany`)
    .regex(PHONE_REGEX, `${label} zawiera niedozwolone znaki`)
    .refine((value) => countDigits(value) >= PHONE_MIN_DIGITS, `${label} musi zawierać co najmniej ${PHONE_MIN_DIGITS} cyfr`)
    .refine((value) => countDigits(value) <= PHONE_MAX_DIGITS, `${label} nie może zawierać więcej niż ${PHONE_MAX_DIGITS} cyfr`);

export const SAFE_TEXT_REGEX = /^(?!.*<[\s/]*[a-zA-Z])[^\p{Cc}\u200B-\u200D\uFEFF]*$/su;
export const SAFE_MULTILINE_TEXT_REGEX = /^(?!.*<[\s/]*[a-zA-Z])(?:[^\p{Cc}\u200B-\u200D\uFEFF]|[\t\n\r])*$/su;

export const safeTextRegexMessage = (label: string): string => `${label} zawiera niedozwolone znaki`;

interface SafeTextOptions {
  min?: number;
  max?: number;
  required?: boolean;
  multiline?: boolean;
  requiredMessage?: string;
}

export const safeTextSchema = (label: string, options: SafeTextOptions = {}) => {
  const { min = 1, max = 200, required = true, multiline = false, requiredMessage } = options;
  const pattern = multiline ? SAFE_MULTILINE_TEXT_REGEX : SAFE_TEXT_REGEX;

  const base = z
    .string({ error: requiredMessage ?? `${label} jest wymagane` })
    .trim()
    .max(max, `${label} nie może przekraczać ${max} znaków`)
    .regex(pattern, safeTextRegexMessage(label));

  if (!required) return base;

  const withRequired = base.min(1, requiredMessage ?? `${label} jest wymagane`);

  return min > 1 ? withRequired.min(min, `${label} musi zawierać minimum ${min} znaki`) : withRequired;
};
